'use client';

import { MobileFullScreenModal } from '@/components/ui/mobile-fullscreen-modal';
import { APP_CATEGORIES } from '@/lib/constants';
import { cn } from '@/lib/utils';

interface MobileCategorySelectorProps {
  isOpen: boolean;
  onClose: () => void;
  selectedCategoryId?: string;
  onCategorySelect: (categoryId: string | null) => void;
}

export function MobileCategorySelector({
  isOpen,
  onClose,
  selectedCategoryId,
  onCategorySelect,
}: MobileCategorySelectorProps) {
  const handleCategorySelect = (categoryId: string) => {
    onCategorySelect(categoryId);
    onClose();
  };

  return (
    <MobileFullScreenModal
      isOpen={isOpen}
      onClose={onClose}
    >
      {/* Category List */}
      <div className="space-y-2">
        {APP_CATEGORIES.map((category) => (
          <button
            key={category.id}
            type="button"
            onClick={() => handleCategorySelect(category.id.toString())}
            className={cn(
              "w-full flex items-center gap-3 p-4 rounded-lg transition-colors",
              selectedCategoryId === category.id.toString()
                ? "bg-primary text-primary-foreground"
                : "hover:bg-gray-100 dark:hover:bg-sidebar-lighter"
            )}
          >
            <span className="text-2xl">{category.icon}</span>
            <span className="font-medium">{category.name}</span>
          </button>
        ))}
      </div>
    </MobileFullScreenModal>
  );
} 